const defaultBranding = {
    // type of product - eg, "forms"
    ProductType: "",
    // menu text to select product search tab - eg, "Forms Search"
    SearchLabel: "Gikipedia Search",
    // meta keyword specified in manifest (might not be the same as product type) - eg, "forms"
    MetaSearchKeyword: "giki",
    // example searches on first run - eg, "Taxes, Immigration, US"
    SearchExample: "Elizabeth II",
    // eg, "Search form titles or tags"
    AutocompletePlaceholder: "Search Gikipedia",
    // eg, "Search our database for forms by typing in a form query in the search box above."
    IntroLI1: "Gikipedia is an online encyclopedia with pictures, facts, and videos.",
    // eg, "You can also browse our forms database by 'tag' located on the left side menu of the page."
    IntroLI2: "Get information and homework help with millions of articles.",
    FirstRunSettings: false,
}

const windowBranding = window.branding || {};

const PRODUCT_SEARCH_PROVIDERS = {
    giki: {
        name: "Gikipedia",
        id: "giki",
        isDefault:true,
        url: "https://gikipedia.org/w/index.php?search={{QUERY}}"
    }
}

const altSearchProvidersUrls = function(query) {
    const altProviders = Object.entries(PRODUCT_SEARCH_PROVIDERS).filter(([key, value]) =>  !value.isDefault);
    return altProviders.map(([key, value]) => {
        return {
            name: value.name,
            url: value.url.replace("{{QUERY}}", query),
        }
    });
}

const DEFAULT_PRODUCT_SEARCH_PROVIDER = PRODUCT_SEARCH_PROVIDERS["giki"].id;

function getBranding(){
    return {
        ...defaultBranding,
        ...windowBranding,
    }
}

export {
    getBranding,
    PRODUCT_SEARCH_PROVIDERS,
    altSearchProvidersUrls,
    DEFAULT_PRODUCT_SEARCH_PROVIDER,
}



// WEBPACK FOOTER //
// ./src/branding.js